import type {Mosaic, MosaicsState, StateSlice} from '@src/stores/types.ts';
import {type MosaicsMode, MODES} from '@src/constants/mosaics.ts';

export const initialState = {
  selected: null, // definition of the selected mosaic.
  mode: MODES.MOSAICS,
};

export const setMosaicSlice: StateSlice<MosaicsState> = set => ({
  ...initialState,
  setMosaicsMode: (mode: MosaicsMode) =>
    set(
      state => {
        state.mosaics.mode = mode;
      },
      undefined,
      'mosaics/setMosaicsMode',
    ),
  setSelectedMosaic: (mosaic: Mosaic | null) =>
    set(
      state => {
        state.mosaics.selected = mosaic;
      },
      undefined,
      'mosaics/setSelectedMosaic',
    ),
});
